// src/pages/Settings.tsx
import React, { useEffect, useState } from 'react'
import api from '../api/axios'
import './Settings.css'
import buttonImg from '../assets/settings/button.png'

export const Settings: React.FC = () => {
  const [username, setUsername] = useState('')
  const [wallet, setWallet]     = useState('')
  const [msg, setMsg]           = useState<string|null>(null)
  const [loading, setLoading]   = useState(true)
  const [error, setError]       = useState<string|null>(null)

  useEffect(() => {
    api.get('/user/me')
      .then(res => {
        setUsername(res.data.username || '')
        setWallet(res.data.wallet   || '')
      })
      .catch(err => {
        console.error(err)
        setError(err.response?.data?.error || err.message)
      })
      .finally(() => setLoading(false))
  }, [])

  const saveUsername = async () => {
    setMsg(null)
    try {
      await api.put('/user/me', { username })
      setMsg('✔️ Username saved!')
    } catch (e: any) {
      setMsg(`❌ ${e.response?.data?.error || e.message}`)
    }
  }

  const saveWallet = async () => {
    setMsg(null)
    try {
      await api.put('/user/me', { wallet })
      setMsg('✔️ Wallet saved!')
    } catch (e: any) {
      setMsg(`❌ ${e.response?.data?.error || e.message}`)
    }
  }

  return (
    <div className="settings-page">
      <div className="settings-container">

        {loading ? (
          <div className="settings-loading">Loading…</div>
        ) : error ? (
          <p className="settings-error">{error}</p>
        ) : (
          <>
            <div className="settings-section">
              <label className="settings-label">
                Username:
                <input
                  className="settings-input"
                  type="text"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                />
              </label>
              <button
                className="settings-btn"
                style={{ backgroundImage: `url(${buttonImg})` }}
                onClick={saveUsername}
              >
                Save Username
              </button>
            </div>

            <div className="settings-section">
              <label className="settings-label">
                Wallet:
                <input
                  className="settings-input"
                  type="text"
                  value={wallet}
                  onChange={e => setWallet(e.target.value)}
                />
              </label>
              <button
                className="settings-btn"
                style={{ backgroundImage: `url(${buttonImg})` }}
                onClick={saveWallet}
              >
                Save Wallet
              </button>
            </div>

            {msg && <p className="settings-msg">{msg}</p>}
          </>
        )}

      </div>
    </div>
  )
}
